import useSWR from "swr";
import { simpleFetcher } from "../fetcher";

interface PreviewUrlResponse {
  previewUrl: string | null;
}

export function usePreviewUrl(documentVersionId?: number) {
  const url = documentVersionId
    ? `/api/v2/document-versions/${documentVersionId}/preview-url`
    : null;

  const { data, error, isLoading } = useSWR<PreviewUrlResponse, Error>(
    url,
    simpleFetcher,
    { revalidateOnFocus: false, revalidateOnMount: true },
  );

  return {
    previewUrl: data?.previewUrl ?? null,
    error,
    isLoading,
  };
}
